var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("svg", { class: _vm.computeClass }, [
    _c("use", { attrs: { "xlink:href": `#icon--${_vm.icon}` } }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }